import { render, staticRenderFns } from "./RegiaoFilterBar.vue?vue&type=template&id=1d8c31d7"
import script from "./RegiaoFilterBar.vue?vue&type=script&lang=js"
export * from "./RegiaoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports